import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import CommonTable, { CommonTableProps } from "../../components/CommonTable";
import {
  addRoom,
  deleteRoom,
  fetchRoom,
  updateRoom,
} from "redux/actions/room";
import { fetchShops } from "redux/actions/shop";
import RoomRes from "../../types/res/room/RoomRes";
import CreateRoomReq from "../../types/req/room/CreateRoomReq";
import UpdateRoomReq from "../../types/req/room/UpdateRoomReq";
import { FormType } from "components/FormField";

const headers: { key: keyof RoomRes; label: string }[] = [
  { key: "shopId", label: "店舗" },
  { key: "name", label: "部屋名" },
  { key: "note", label: "備考" },
  { key: "sort", label: "並び順" },
  { key: "isActive", label: "使用可否" },
];

const Room: React.FC = () => {
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.account.staff.companyId);
  const rooms = useSelector((state) => state.room);
  const shops = useSelector((state) => state.shop);

  useEffect(() => {
    dispatch(fetchShops(companyId));
    dispatch(fetchRoom(companyId));
  }, [companyId, dispatch]);

  const forms = [
    {
      label: "店舗",
      key: "shopId",
      type: FormType.Select,
      options:
        shops?.map((s) => ({ id: String(s.shopId), name: s.name })) || [],
      // MUI Select の value 比較で number vs string mismatch を回避するため
      // defaultValues.shopId (number) を string に変換して formData.shopId にセット
      value: (val: any) => String(val),
    },
    {
      label: "部屋名",
      key: "name",
      type: FormType.Text,
    },
    {
      label: "備考",
      key: "note",
      type: FormType.TextArea,
    },
    {
      label: "並び順",
      key: "sort",
      type: FormType.Number,
    },
    {
      label: "使用可否",
      key: "isActive",
      type: FormType.Boolean,
      options: [
        { id: "0", name: "使用不可" },
        { id: "1", name: "使用可" },
      ],
    },
  ];

  return (
    <RoomTable
      title="部屋リスト"
      formId="roomForm"
      forms={forms}
      rows={headers}
      data={rooms}
      addType={CreateRoomReq}
      updateType={UpdateRoomReq}
      addFunc={(formData: any) => async (d: any) => {
        return await addRoom(companyId, formData)(d);
      }}
      updateFunc={(formData: any) => async (d: any) => {
        return await updateRoom(companyId, formData)(d);
      }}
      deleteFunc={(item: any) => async (d: any) => {
        return await deleteRoom(companyId, { roomId: item.roomId })(d);
      }}
      values={[
        (s) => s.shop?.name || "未設定",
        (s) => s.name,
        (s) => s.note || "",
        (s) => s.sort || "未設定",
        (s) => (s.isActive ? "使用可" : "使用不可"),
      ]}
    />
  );
};

const RoomTable = styled<
  React.FC<CommonTableProps<RoomRes, CreateRoomReq, UpdateRoomReq>>
>(CommonTable)`
  margin-top: 24px;
`;

export default Room;
